// selectedSitesTable.tsx
//
// (c) NCR Voyix Corporation 2025. All rights reserved.

import React from 'react'
import { connect } from 'react-redux'
import { DataGridPro, GridColDef } from '@mui/x-data-grid-pro'
import { RootState } from '../../../redux'

const rowHeight = 36
const minHeight = 41

function mapStateToProps(state: RootState) {
  return {
    selectedSites: state.deploymentLite.deploymentSitesIds,
    companySites: state.sites.sites
  }
}

type StateProps = ReturnType<typeof mapStateToProps>
type SelectedSitesTableProps = StateProps

function SelectedSitesTable(
  {
    selectedSites,
    companySites
  }: Readonly<SelectedSitesTableProps>
): JSX.Element {
  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: 'Site ID',
      maxWidth: 90,
      minWidth: 90,
      sortable: false,
      flex: 1,
      headerAlign: 'center'
    },
    {
      field: 'siteName',
      headerName: 'Site Name',
      flex: 1,
      headerAlign: 'center'
    }
  ]

  const rows = selectedSites.map((siteId) => ({
    id: siteId,
    siteName: companySites[siteId].name
  }))

  const maxHeight = minHeight + (Math.min(5, rows.length) * rowHeight)

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: minHeight + rowHeight,
        maxHeight,
        height: maxHeight
      }}
    >
      <DataGridPro
        rows={rows}
        columns={columns}
        density="compact"
        hideFooter
      />
    </div>
  )
}

export default connect(mapStateToProps)(SelectedSitesTable)
